var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"app_footer"},[_c('div',{staticClass:"iconfont"},[(_vm.gsinfo.lxdh)?_c('span',[_vm._v("联系电话："+_vm._s(_vm.gsinfo.lxdh))]):_vm._e(),(_vm.gsinfo.gsdz)?_c('span',{staticStyle:{"margin":"0 60px"}},[_vm._v("公司地址："+_vm._s(_vm.gsinfo.gsdz))]):_vm._e(),_c('span',[_vm._v("CopyRight © "+_vm._s(_vm.gsinfo.gsmc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }